import React from "react";
import "./style.scss";
import InputError from "../InputError/InputError";
import DOMPurify from "dompurify";

export default function Switch({
  errors,
  label,
  name,
  register,
  validationRules,
  ...rest
}) {
  const showError = errors?.message;
  
  return (
    <>
      <div className={`checkbox ${showError ? "error" : ""}`}>
        <label
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(label),
          }}
          className="label"
          htmlFor={name}
        />
        <div className="switch">
          <input
            {...register(`${name}`, {
              ...validationRules,
            })}
            className="input"
            id={name}
            name={name}
            type="checkbox"
            {...rest}
          />
          <span className="slider"></span>
        </div>
      </div>
      {showError && <InputError errorMessage={errors.message} />}
    </>
  );
}
